import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ListTodo, UserCheck } from "lucide-react";

interface ViewModeToggleProps {
  mode: 'created' | 'assigned';
  onChange: (mode: 'created' | 'assigned') => void;
}

export function ViewModeToggle({ mode, onChange }: ViewModeToggleProps) {
  return (
    <Card className="p-1 inline-flex gap-1 bg-muted">
      <Button
        variant={mode === 'created' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onChange('created')}
        className="gap-2"
      >
        <ListTodo className="h-4 w-4" />
        Tasks I Created
      </Button>
      <Button
        variant={mode === 'assigned' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onChange('assigned')}
        className="gap-2"
      >
        <UserCheck className="h-4 w-4" />
        Tasks Assigned to Me
      </Button>
    </Card>
  );
}
